( function () {
	'use strict';

	function templateDigitalSignatureModalCtrl ( modalInstance, digitalSignatureModel ) {
		var self = this;

		function confirmModal () {
			digitalSignatureModel.model.allowSignature = self.allowSignature;
			modalInstance.dismiss( 'cancel' );
		}

		self.isViewOnly     = digitalSignatureModel.isViewOnlyMode;
		self.confirmModal   = confirmModal;
		self.allowSignature = Boolean( digitalSignatureModel.model.allowSignature );
	}

	templateDigitalSignatureModalCtrl.$inject = [ '$modalInstance', 'templateDigitalSignatureModel' ];

	angular
		.module( 'app.templates' )
		.controller( 'templateDigitalSignatureModalCtrl', templateDigitalSignatureModalCtrl );
} )();
